import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type PostCountAssessment from '@linc-technologies/linced-common/models/people/post-count-assessment';
import type PostCountGoal from '@linc-technologies/linced-common/models/people/post-count-goal';
import type PostCountPage from '@linc-technologies/linced-common/models/people/post-count-page';

// Proto: none. The person serializer builds this shape from people.PostCount.
export default class PostCounts extends Fragment {
  declare [Type]: 'people/post-counts';

  @fragmentArray('people/post-count-page')
  declare pages: FragmentArray<PostCountPage>;

  @fragmentArray('people/post-count-page')
  declare pagesByYear: FragmentArray<PostCountPage>;

  @fragmentArray('people/post-count-goal')
  declare goals: FragmentArray<PostCountGoal>;

  @fragmentArray('people/post-count-assessment')
  declare assessmentModules: FragmentArray<PostCountAssessment>;
}
